export default __webpack_public_path__ + "static/media/sms.67d93762.jpg";